import { useEffect } from "react";
import { useSoundContext } from "../context";
import useSound from "use-sound";

const useAudio = (soundFile) => {
  const { isPlaying } = useSoundContext(); // Use the global sound context
  console.log("🚀 ~ useAudio ~ isPlaying:", isPlaying);
  const [play, { stop }] = useSound(soundFile, {
    loop: true, // Enable looping if required
    volume: 1, // Set volume to max
  });

  useEffect(() => {
    // Play or stop the sound based on the isPlaying state
    if (isPlaying) {
      play();
      console.log("Playing sound");
    }

    // Clean up when the component unmounts or soundFile changes
    return () => {
      stop();
    };
  }, [isPlaying]);

  return {};
};

export default useAudio;
